var getClickThroughSourceFromParamsString = function (paramsString) {
    var searchParams = new URLSearchParams(paramsString);
    var page = searchParams.get("sourcePage") || undefined;
    var element = searchParams.get("sourceElement") || undefined;
    var sourceType = searchParams.get("sourceType") || undefined;
    return page || element || sourceType
        ? {
            page: page,
            element: element,
            /* eslint-disable @typescript-eslint/naming-convention */
            source_type: sourceType,
        }
        : undefined;
};
var getClickThroughSource = function (page, element, sourceType) {
    return page || element || sourceType
        ? {
            page: page,
            element: element,
            /* eslint-disable @typescript-eslint/naming-convention */
            source_type: sourceType,
        }
        : getClickThroughSourceFromParamsString(window.location.search);
};
var getPageName = function (pageType, site, siteSection) { return [site, siteSection, pageType].filter(Boolean).join(":"); };
// eslint-disable-next-line @typescript-eslint/ban-types
export var getPageData = function (data) {
    var pageType = data.pageType, _a = data.site, site = _a === void 0 ? "rea" : _a, siteSection = data.siteSection, siteSubSection = data.siteSubSection, siteSubSubSection = data.siteSubSubSection, siteSubSubSubSection = data.siteSubSubSubSection, articleName = data.articleName, variantName = data.variantName, breadcrumbs = data.breadcrumbs, clickThroughSourcePage = data.clickThroughSourcePage, clickThroughSourceElement = data.clickThroughSourceElement, clickThroughSourceType = data.clickThroughSourceType, platform = data.platform, responsiveLayout = data.responsiveLayout;
    // eslint-disable-next-line @typescript-eslint/ban-types
    return function () { return ({
        page: {
            schema: "iglu:au.com.realestate/page/jsonschema/2-0-8",
            data: {
                /* eslint-disable @typescript-eslint/naming-convention */
                page_name: getPageName(pageType, site, siteSection),
                page_type: pageType,
                site: site,
                site_section: siteSection,
                site_sub_section: siteSubSection,
                site_sub_sub_section: siteSubSubSection,
                site_sub_sub_sub_section: siteSubSubSubSection,
                article_name: articleName,
                variant_name: variantName,
                breadcrumbs: breadcrumbs,
                click_through_source: getClickThroughSource(clickThroughSourcePage, clickThroughSourceElement, clickThroughSourceType),
                language: "english",
                platform: platform.getName(),
                responsive_layout: responsiveLayout,
                rendered_on: platform.getRenderedOn(),
            },
        },
    }); };
};
//# sourceMappingURL=getPageData.js.map